import { useEffect, useState } from 'react';

// TCX-1122: the pinned header shows its shadow only once content scrolls under
// it, so it sits flat at the top of the page. The page scrolls on the document,
// so window.scrollY is the signal.
export const useIsPageScrolled = (): boolean => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const update = () => setIsScrolled(window.scrollY > 0);
    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, []);

  return isScrolled;
};
